import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Chip, List, Paper, Radio, Typography } from '@material-ui/core';
import { priceFormat } from '../hooks/currency';
import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/Remove';
import { getTotalPriceVariant } from '../hooks/price';
import {  getOptionPrice, getOptionText} from '../hooks/additions'


const useStyles = makeStyles((theme) => ({


  contentVariant: {
    backgroundColor: theme.palette.background.grey,
    padding: theme.spacing(1), 
    borderRadius: "0.5rem",
  },


  title: {
    display: 'flex',
    flexDirection: 'row',
    //backgroundColor: 'blue',
  },
  name: {
    marginRight:  theme.spacing(1),
  },
  price: {
    marginLeft: theme.spacing(1),
    marginLeft:'auto',
  },


  contentBody: {
    display: 'flex',
    flexDirection: 'row',
    flexFlow:'space-beetwen',
    //backgroundColor: 'red',
    marginLeft:  theme.spacing(1),
    marginTop: theme.spacing(1),

  },

  listOptions: {
    width:"80%",
    display: 'flex',
    flexDirection: 'column',
   // backgroundColor: 'blue',
  },

  contentOption: {
    display: 'flex',
    flexDirection: 'row',
  },

  actionRemove: {
    width:"20%",
    display: 'flex',
    flexDirection: 'column',
    //backgroundColor: 'yellow',
    alignItems:'flex-end',
    justifyContent:'end'
  },
  paper: {
    backgroundColor: theme.palette.background.grey,
  },

}));



export default function ItemVariant(props) {
  const classes = useStyles();
  const {item, showCurrency, variant, currency, onRemoveVariant} = props;
  //console.log('ItemVariant, variant: ',variant);

  const getTotalPriceLabel = (total)=>{
    return priceFormat(currency.style,total,showCurrency); 
  }
  


  return (
    <div className={classes.contentVariant}> 
       <div className={classes.title}>
          <Typography variant="subtitle2" color="textPrimary">
              {item.name}
          </Typography>
         
          <div className={classes.price}>  
            <Typography variant="body2" color="textPrimary">
                    {getTotalPriceLabel( getTotalPriceVariant(item,variant.options))}
            </Typography>
          </div>
       </div>
       <div className={classes.contentBody}>
            <div className={classes.listOptions}>
            {
            variant.options.map((option, index)=>(         
                  <div className={classes.contentOption} key={index}>                    
                      <Typography variant="body2" color="textPrimary">
                          {getOptionText(option)}
                      </Typography>             
                      <Typography ml={1} variant="body2" color="text.muted">
                              {getOptionPrice(currency,option)}
                      </Typography>                     
                  </div>

                ))
            }
           </div>
           {onRemoveVariant && 
           <div className={classes.actionRemove}>
              <Paper elevation={1} >
              <div className={classes.paper}>  
              <IconButton size='small' aria-label="remove" onClick={()=>onRemoveVariant(item,variant)}>
                <RemoveIcon />
              </IconButton>
              </div>
              </Paper>
            </div> 
            }
    </div>
    </div>
  );
}
